import { Component }        from '@angular/core';
import { NavController }    from 'ionic-angular';
import { MenuController }   from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';


import { SelectMoleculePage }    from '../select-molecule/select-molecule';
import { FindCompetitorPage }    from '../find-competitor/find-competitor';
import { DirectSearchPage   }    from '../direct-search/direct-search';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  selector:    'page-gasmixtures',
  templateUrl: 'gasmixtures.html'
})

export class GasmixturesPage
{
  items           : Array<{title: string, page: any, icon: string, background: string, overlay: string}>;
  searchTitle     : string = 'Direct search';
  competitorTitle : string = 'Find a competitor';
  mixtureTitle    : string = 'Select a mixture';

  constructor(public navCtrl    : NavController,
              public menuCtrl   : MenuController,
              public translate  : TranslateService,
              private analytics  : GoogleAnalytics)
  {
    this.items = [];
    this.initUnitTranslation();
    
    this.items.push(
      {
        title:      this.searchTitle,
        page:       DirectSearchPage,
        icon:       'assets/mixtures_white_icn.png',
        background: 'assets/mixtures_bg.png',
        overlay:    'assets/menu_overlay_1.png'
      });

    this.items.push(
      {
        title:      this.competitorTitle,
        page:       FindCompetitorPage,
        icon:       'assets/mixtures_white_icn.png',
        background: 'assets/mixtures_bg.png',
        overlay:    'assets/menu_overlay_2.png'
      });

      this.items.push(
        {
          title:      this.mixtureTitle,
          page:       SelectMoleculePage,
          icon:       'assets/mixtures_white_icn.png',
          background: 'assets/mixtures_bg.png',
          overlay:    'assets/menu_overlay_2.png'
        });
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Gas Mixtures result");
  }

  initUnitTranslation()
  {
    var context = this;

    this.translate.get('DIRECT_SEARCH').subscribe(
      value => {
        context.searchTitle = value;
      })
    this.translate.get('FIND_A_COMPETITOR').subscribe(
      value => {
        context.competitorTitle = value;
      })
    this.translate.get('SELECT_A_MIXTURE').subscribe(
      value => {
        context.mixtureTitle = value;
      })
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }

  itemTapped(event, item)
  {
    this.navCtrl.push(item.page, {}, {animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/gasmixtures/gasmixtures.ts